import React, { useState, useContext } from "react";
import { Button, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";

import { DateFormat } from "../../../helpers";
import Sidebar from "../../../components/Sidebar";
import PreviewBanner from "../../../components/PreviewBanner";
import { StoreContext } from "../../../context";
import './index.css'

const { Text } = Typography;

export default function AdSidebar({
  visible = false,
  data = {},
  onClose,
  editAdHandler,
  onUploadDone,
}) {
  const { storeId } = useContext(StoreContext);
  const [loading, setLoading] = useState(false);

  const getTargetText = () => {
    if (data.product_name) {
      return `${data.product_name}${data.variant_name ? ` - ${data.variant_name}` : ''}`;
    } else if (data.sub_category_name) {
      return `${data.category_name} - ${data.sub_category_name}`;
    } else if (data.category_name) {
      return data.category_name;
    } else if (data.url) {
      return data.url;
    }
    return "Not specified";
  };

  const renderInfoSection = (title, children) => (
    <div className="info-section">
      <Text className="section-title">
        {title}
      </Text>
      {children}
    </div>
  );

  const renderDetailItem = (label, value, isUrl = false) => {
    if (!value) return null;
    
    return (
      <div className="detail-item">
        <Text className="detail-label">
          {label}
        </Text>
        {isUrl ? (
          <a 
            href={value} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="detail-link"
          >
            {value}
          </a>
        ) : (
          <Text className="detail-value">{value}</Text>
        )}
      </div>
    );
  };

  return (
    <Sidebar
      title="Banner Details"
      visible={visible}
      onClose={onClose}
      loading={loading}
      footer={
        !storeId && (
          <div style={{ 
            display: 'flex',
            gap: '12px',
            padding: '16px 0'
          }}>
            <Button
              icon={<EditOutlined />}
              onClick={editAdHandler}
              type="primary"
              size="large"
              style={{
                width: '100%',
                height: '48px',
                borderRadius: '8px'
              }}
            >
              Edit Banner Details
            </Button>
          </div>
        )
      }
    >
      <div style={{ padding: '0 4px' }}>
        {/* Banner Preview */}
        {data.banner_image && (
          <div style={{ marginBottom: '20px' }}>
            <Text className="section-title">
              Banner Preview
            </Text>
            <PreviewBanner src={data.banner_image} />
          </div>
        )}

        {/* Basic Information */}
        {renderInfoSection("Basic Information", (
          <>
            {renderDetailItem("Banner Name", data.name)}

            {renderDetailItem("Banner Type", data.banner_type || "homepage")}

            <div className="detail-item">
              <Text className="detail-label">
                Action Type
              </Text>
              <span className="banner-type-badge">
                {data.type === "sub_category" ? "Sub Category" : data.type}
              </span>
            </div>

            {renderDetailItem("Created Date", DateFormat(data.created_at))}
          </>
        ))}

        {/* Target & Action */}
        {renderInfoSection("Target & Action", (
          <>
            <div className="detail-item">
              <Text className="detail-label">
                {data.type === "product" ? "Product" : 
                 data.type === "category" ? "Category" :
                 data.type === "sub_category" ? "Sub Category" :
                 data.type === "url" ? "URL" : "Target"}
              </Text>
              {data.type === "url" ? (
                <a 
                  href={data.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="detail-link"
                >
                  {data.url}
                </a>
              ) : (
                <Text className="detail-value">
                  {getTargetText()}
                </Text>
              )}
            </div>
          </>
        ))}

        {/* Validity Period */}
        {renderInfoSection("Validity Period", (
          <>
            {renderDetailItem("Valid From", DateFormat(data.valid_from, "DD MMM YY"))}
            {renderDetailItem("Valid Till", DateFormat(data.valid_till, "DD MMM YY"))}
            
            <div className="detail-item">
              <Text className="detail-label">
                Duration
              </Text>
              <Text className="detail-value">
                {DateFormat(data.valid_from, "DD MMM YY")} - {DateFormat(data.valid_till, "DD MMM YY")}
              </Text>
            </div>
          </>
        ))}

        {/* Description */}
        {data.description && renderInfoSection("Description", (
          <div className="description-box">
            <Text className="description-text">
              {data.description}
            </Text>
          </div>
        ))}
      </div>
    </Sidebar>
  );
}